// extracted by mini-css-extract-plugin
export var RakuuruFooter = "RakuuruFooter-module--RakuuruFooter--1Qfxi";
export var RakuuruFooter__top = "RakuuruFooter-module--RakuuruFooter__top--2p_ZI";
export var RakuuruFooter__logo = "RakuuruFooter-module--RakuuruFooter__logo--1M7iw";
export var RakuuruFooter__info = "RakuuruFooter-module--RakuuruFooter__info--13ck3";
export var RakuuruFooter__btm = "RakuuruFooter-module--RakuuruFooter__btm--1Q7kR";